import { EMode, TSeoKeywordData } from '@microfrontends/app-shell-v2'
import { ELanguage } from '@microfrontends/react-components'
import { useRouter } from 'next/router'
import CompanyDetail from '../../components/CompanyDetail'
import { ICompanyInfo } from '../../components/CompanyDetail/type'
import { IAuthUser } from '../../services/authService'
import { getServerSideProps } from '../../ssr'
import { AppStoreProvider } from '../../store'
import { TInfoPath, TMetaHead } from '../../helpers/urlHelper'
import { TInfoCompanyOCI } from '../../services/companyDetailService'

interface TPageProps {
    jsToken: string
    wsToken: string
    user: IAuthUser
    companyProfile: ICompanyInfo
    appMode: EMode
    isRobot: boolean
    companyJobs: any
    infoPath: TInfoPath
    metaHead: TMetaHead
    companyOCIData: TInfoCompanyOCI | null | undefined
    seoKeywords: TSeoKeywordData[]
}

const CompanyDetailPage = (props: TPageProps) => {
    const {
        jsToken,
        wsToken,
        user,
        companyProfile,
        appMode,
        isRobot,
        companyJobs,
        infoPath,
        metaHead,
        companyOCIData,
        seoKeywords
    } = props

    const router = useRouter()
    const { query } = router
    const companyName: string =
        query && typeof query.companyName === 'object' ? query.companyName.join(',') : (query.companyName as string)

    return (
        <AppStoreProvider langCode={ELanguage.VI} isRobot={isRobot} companyJobs={companyJobs}>
            <CompanyDetail
                seoKeywords={seoKeywords}
                jsToken={jsToken}
                wsToken={wsToken}
                user={user}
                appMode={appMode}
                langCode={ELanguage.VI}
                companyName={companyName || ''}
                companyProfile={companyProfile}
                infoPath={infoPath}
                companyOCIData={companyOCIData}
                isCLP={false}
                metaHead={metaHead}
            />
        </AppStoreProvider>
    )
}

export default CompanyDetailPage

export { getServerSideProps }
